import { Row, Col, Divider } from "antd";
import OrgDocUploadCard from "../../../components/DocUploadCard/OrgDocUploadCard";
import { DOC_CONFIG, GLOBAL_CONSTANTS, TITLE_TXT } from "../../../constants/constants";

const KycUploadDocs = ({ kycData, busType, orgId, onFileChange, isReview, organizationId, token }) => {
    let docsToShow = DOC_CONFIG[busType];

    if (isReview && !kycData?.kycDetails?.others?.docId) {
        docsToShow = docsToShow?.filter(doc => doc.key !== "others");
    }

    const mapKycData = (key) => {

        const doc = kycData?.kycDetails[key];
        const mapped = {
            fileUrl: doc?.docUrl,
            fileName: decodeURIComponent(doc?.docUrl.split("/").pop()),
            isVerified: doc?.isVerified,
            rejected: doc?.rejected,
            docId: doc?.docId
        };

        return mapped
    }

    return (
        <>
            <Row gutter={[24, 24]}>
                {docsToShow?.map((doc) => (
                    <Col xs={24} md={12} key={doc.key}>
                        <OrgDocUploadCard
                            fileTitle={doc.title}
                            fileType={doc.type}
                            fileData={mapKycData(doc.key)}
                            orgId={orgId}
                            isReview={isReview}
                            onFileChange={(file) => onFileChange(doc.key, file)}
                            token={token}
                            organizationId={organizationId}
                        />
                    </Col>
                ))}
            </Row>
            {!kycData?.financialEval && (
                <>
                    <Divider style={{ borderColor: "#CBD5E2" }} />
                    <Row gutter={[24, 24]}>
                        <Col xs={24} md={12}>
                            <OrgDocUploadCard
                                fileTitle={TITLE_TXT.FIN_EVAL}
                                fileType={GLOBAL_CONSTANTS.XLSX}
                                orgId={orgId}
                                isReview={isReview}
                                onFileChange={(file) => onFileChange("fin_eval", file)}
                                token={token}
                                organizationId={organizationId}
                            />
                        </Col>
                    </Row>
                </>
            )}

        </>
    );
};

export default KycUploadDocs;
